import React from 'react';
import './heroSection.css';
import { useTranslation } from 'react-i18next';

const HeroSection = () => {
  const { t } = useTranslation(); 

  return (
    <div className="hero-section">
      <video autoPlay loop muted playsInline className="hero-video">
        <source src="/images/heroSection/motonurk_ig%20(2).mp4" type="video/mp4" />
        {t('heroSection.videoUnsupported')}
      </video>

      <div className="hero-content">
        <h1 className="hero-title">{t('heroSection.title')}</h1>
        <p className="hero-date">{t('heroSection.date')}</p>
        {/* Кнопки регистрации сохранены для последующего восстановления.
        <div className="hero-buttons">
          <button
            className="hero-button"
            onClick={() => {
              setActiveButton('retroTech');
              scrollToSection('retroTech');
            }}
          >
            {t('heroSection.retroTechButton')}
          </button>
          <button
            className="hero-button"
            onClick={() => {
              setActiveButton('fair');
              scrollToSection('fair');
            }}
          >
            {t('heroSection.fairButton')}
          </button>
        </div>
        */}
      </div>
    </div>
  );
};

export default HeroSection;
